import anime from 'animejs'

const wrapper = document.querySelector('[data-preloader]')
const image = document.querySelector('[data-preloader-img]')
const progress = document.querySelector('[data-preloader-progress]')

const animations = [
  {
    targets: image,
    translateY: ['100%', 0],
    delay: 1000,
  },
  {
    targets: progress,
    scaleX: [0, 1],
    complete: () => {
      progress.style.transformOrigin = 'right center'
    },
  },
  {
    targets: progress,
    scaleX: [1, 0],
  },
  {
    targets: image,
    translateY: [0, '100%'],
  },
]

const loadingAnimation = () => {
  const tl = anime.timeline({
    duration: 800,
    easing: 'cubicBezier(.4,0,0,1)',
  })

  try {
    const longPreloader = localStorage.getItem('shortPreloader') === null
    if (longPreloader) {
      localStorage.setItem('shortPreloader', '')
      animations.forEach(animation => tl.add(animation))
    }

    tl.add({
      targets: wrapper,
      opacity: [1, 0],
      duration: 800,
      delay: longPreloader ? 0 : 800, // wait for first 800ms when CPU can be overloaded
      easing: 'linear',
      complete: () => {
        document.documentElement.classList.add('preloader-removed')
      },
    })
  } catch (e) {
    if (wrapper) {
      wrapper.style.display = 'none'
    }
  }

  return tl.finished
}

export default loadingAnimation
